import { TicketOwner, TicketOwnerSalutationEnum } from "@/generated/openapi"

interface PersonalData {
  salutation: TicketOwnerSalutationEnum;
  title: string;
  givenName: string;
  surName: string;
  organization: string;
  email: string;
  phone: string;
  accessible: boolean;
}

function createDefaultPersonalData(): PersonalData {
  return {
    salutation: TicketOwnerSalutationEnum.None,
    title: '',
    givenName: '',
    surName: '',
    organization: '',
    email: '',
    phone: '',
    accessible: false
  }
}

function asTicketOwner(personalData: PersonalData): TicketOwner {
  return {
    email: personalData.email,
    firstName: personalData.givenName,
    lastName: personalData.surName,
    salutation: personalData.salutation,
    organisation: personalData.organization,
    phone: personalData.phone,
    title: personalData.title,
    accessibility: personalData.accessible
  }
}

export {
  PersonalData,
  createDefaultPersonalData,
  asTicketOwner
}
